import styled from "styled-components";
import { BiChevronDown } from "react-icons/bi";

interface FieldProps {
  marginBottom?: string;
  marginLeft?: string;
}

interface ToggleProps {
  margin?: string;
  customWidth?: string;
}

interface FormProps {
  customWidth?: string;
}

export const Content = styled.form<FormProps>`
  display: flex;
  flex-direction: column;
  width: ${({ customWidth }) => customWidth ? customWidth : '100%'};
  position: relative;
  border: ${({ theme }) => `1px solid ${theme.colors.blue.dark}`};
  border-radius: 16px;
  padding: 32px 32px 64px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: calc(100% - 64px);
    margin: auto;
    padding: 0 0 20px;
    border: none;
    border-radius: 0;
  }
`;


export const Field = styled.div<FieldProps>`
  position: relative;
  width: 100%;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0 };
  margin-left: ${({ marginLeft }) => marginLeft || 0 };

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    margin-bottom: 20px;
  }
`;

export const Combo = styled.div<FieldProps>`
  display: flex;
  position: relative;
  width: 100%;
  margin-bottom: ${({ marginBottom }) => marginBottom || 0 };

  > div {
    margin-right: 32px;
  }
`;

export const Label = styled.label`
  display: block;
  color: ${({ theme }) => theme.colors.blue.dark };
  text-transform: uppercase;
  font-size: 17px;
  margin-bottom: 16px;
  white-space: nowrap;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    font-size: 14px;
    margin-bottom: 8px;
  }
`;

export const Divider = styled.span`
  display: inline-block;
  padding: 0 12px;
  line-height: 65px;
  color: ${({ theme }) => theme.colors.gray.darker};
`;

export const Button = styled.button`
  display: inline-block;
  background-color: ${({ theme }) => theme.colors.blue.dark };
  color: ${({ theme }) => theme.colors.pink.light };
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  max-width: 256px;
  height: 72px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: none;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    max-width: 100%;
    height: 60px;
    position: static;
    transform: none;
    margin-top: 16px;
  }
`;

export const ChevronIcon = styled(BiChevronDown)`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const Toggle = styled.span<ToggleProps>`
  display: none;
  
  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    color: ${({ theme }) => theme.colors.blue.dark};
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 22px;
    height: 60px;
    width: ${({ customWidth }) => customWidth ? customWidth : 'auto'};
    margin: ${({ margin }) => margin ? margin : '0 14px'};
    border-top: ${({ theme }) => `2px solid ${theme.colors.blue.dark}`};
  }
`;